<template lang="html">
    <my-upload
        ref="crops"
        field="img"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :width="300"
        :height="400"
        url="/api/agremiado/fotoCarnet"
        :params="params"
        :headers="headers"
        :max-size="2048"
        :max-width="2000"
        img-format="png"
        noCircle
        lang-type="es-MX"
        ></my-upload>
</template>

<script>
import { mapGetters } from 'vuex'
import myUpload from 'vue-image-crop-upload'

export default {

  props: {
    cpc: {
      type: String,
      required: true
    },
    showUpload: {
        type: Boolean,
        required: true,
        default: false
    }
  },

  components: {
    myUpload
  },

  computed: mapGetters({
    token: 'authToken'
  }),

  created() {
    this.headers.Authorization = 'Bearer ' + this.token
  },

    watch: {
        show(v) {
            if(!v){
                this.$emit('upload', v)
            }
        },
        showUpload(v) {
            if(v){
                this.show = v
            }
        }
    },

  data () {
    return {
      statusUpload: false,
      show: false,
      params: {
        cpc: '',
        tipo: 'foto'
      },
      headers: {
        smail: '*_~',
        Authorization: ''
      },
      imgDataUrl: '', // the datebase64 url of created image
      datos: null
    }
  },

  methods: {

    cropSuccess(imgDataUrl, field) {
      this.params.cpc = this.cpc
      this.imgDataUrl = imgDataUrl
    },

    cropUploadSuccess(jsonData, field) {
      this.statusUpload = true
      this.datos = jsonData
      this.$emit('userdata', jsonData)
    },

    cropUploadFail(status, field) {
      this.statusUpload = false
      this.$store.dispatch('responseMessage', {
        type: 'error',
        text: 'No se logro guardar el archivo, Intente nuevamente'
      })
    }

  }


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/logouniversidad/upload_file.vue